import { useEffect, useState } from 'react'
import { Form, Button } from 'react-bootstrap'

import axios from 'axios'
require('dotenv/config');

const bot = axios.create({

    baseURL: 'http://localhost:5000/'

});


//import './styles.css';

import NavBar from '../../components/NavBar/NavBar.js'
import SideBar from '../../components/SideBar'
import MuiAlert from '@material-ui/lab/Alert'
import ToastAnimated, { showToast } from '../../ui-lib/toast'

function WhatsBot() {
    const idEmpresa = localStorage.getItem('idEmpresa')

    const [numero, setNumero] = useState()
    const [msg, setMsg] = useState()

    const [numeroAler, setNumeroAlert] = useState()
    const [nome, setNome] = useState()
    const [servidor, setServidor] = useState()

    function Alert(props) {
        return <MuiAlert elevation={3} variant="filled" {...props} />
    }
    async function handleSend(event) {
        await bot.post('/SendMsg', {
            numero: numero,
            msg: msg,
        })
            .then(
                showToast({
                    type: 'success',
                    message: 'Mesagem enviada',
                    pauseOnFocusLoss: true,
                })
            )
            .catch(Alert('ERRO AO ENVIAR MESAGEM '))
    }

    async function handleSendAlert(event) {
        await bot.post('/Report', {
            numero: numeroAler,
            nome: nome,
            servidor: servidor
        })
            .then(
                showToast({
                    type: 'success',
                    message: 'Mesagem enviada',
                    pauseOnFocusLoss: true,
                })
            )
            .catch(Alert('ERRO AO ENVIAR MESAGEM '))
    }
    return (
        <div>
            <NavBar />
            <div className="MainDashboardMain">

                <div className="main">
                    <h1>
                        Enviar mensagem pelo bot
                            </h1>
                    <Form>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>Numero para enviar</Form.Label>
                            <Form.Control
                                type="email"
                                value={numero}
                                onChange={(event) => {
                                    setNumero(event.target.value)
                                }}
                            />
                        </Form.Group>

                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Enviar mensagem pelo bot</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={msg}
                                onChange={(event) => {
                                    setMsg(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <ToastAnimated />
                        <Button onClick={handleSend}>Enviar</Button>
                    </Form>

                    <br />
                    <h1>
                        Enviar alerta pelo bot
                            </h1>
                    <Form>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>Numero para enviar</Form.Label>
                            <Form.Control
                                type="email"
                                value={numeroAler}
                                onChange={(event) => {
                                    setNumeroAlert(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Nome da empresa ou pessoa que irá receber</Form.Label>
                            <Form.Control
                                value={nome}
                                onChange={(event) => {
                                    setNome(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Servidor</Form.Label>
                            <Form.Control
                                value={servidor}
                                onChange={(event) => {
                                    setServidor(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <ToastAnimated />
                        <Button onClick={handleSendAlert}>Enviar</Button>
                    </Form>
                </div>
            </div>
            <br />
        </div>
    )
}

export default WhatsBot 
